import { useState } from 'react'
import { Icons } from '@journ/ui/icons'
import { Button } from '@journ/ui/button'
import { Sheet, SheetContent } from '@journ/ui/sheet'
import { Link } from '@/libs/router'
import { MainMenu } from './main-menu'

const MobileMenu = () => {
	const [isOpen, setOpen] = useState(false)

	return (
		<Sheet open={isOpen} onOpenChange={setOpen}>
			<Button
				variant='outline'
				size='icon'
				onClick={() => setOpen(true)}
				className='rounded-full w-8 h-8 items-center relative flex md:hidden'
			>
				<Icons.Menu size={16} />
			</Button>
			<SheetContent side='left' className='border-none rounded-none -ml-4'>
				<div className='ml-2 mb-8'>
					<Link to='/'>
						<Icons.LogoSmall />
					</Link>
				</div>
				<div className='-ml-2'>
					<MainMenu isExpanded onSelect={() => setOpen(false)} />
				</div>
			</SheetContent>
		</Sheet>
	)
}

export { MobileMenu }
